module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Saucepan-1ec9a03b6e44e3606493c195be7c30e5.svg";